import script from "./UkSelfCertificationNotEligibleModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UkSelfCertificationNotEligibleModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__